/****************ELEMENTS*****************/
//this obj define, the actions realeted to each
//th>table header and td
const timeDate = require("../../../../../js-handler/time-date");

function getTdDataDetail(dest, entity, dbid) {
  return `data-detail='{ 
      "click": [ 
        {"dest":"ripple"},
        {"dest":"${dest}", "elem":"fullcont", "id":"${dest}-fullcont", "act":"selectOne", "entity":"${dest}", "dbid":"${dbid}"}
      ],
      "clickRight": [ 
        {"dest":"${dest}", "elem":"dt", "act":"trMenu", "id":"trMenu", "entity":"${dest}", "dbid":"${dbid}"}
      ] 
  }'`;
}

export const tableDetail = {

  entity: "clientActivity", //name table on the db
  dest: "clientActivity", //name of the entity on the system

  //action for body
  //left click, directly to the fullcont
  tdDataDetail: `data-detail='{ "click": [ {"dest":"ripple" },
                                            {"dest":"clientActivity", "elem":"page", "act":"removeFc"}  ],
                                
                                 "clickRight": [{"dest":"purchase", "elem":"dt", "act":"trMenu", "id":"trMenu",  "entity":"purchase", "dbid": "#dbid" } ]  }'`,

  // andry 28/12/2023
  filter: {
    mainFilterFields: [
      "purchase.code",
    ],
    mainFilterValues: ["", ""],
    andFilterFields: [""],
    andFilterValues: [""],
  },
};

/****************ELEMENTS*****************/

//each element could organize their data diferent
export function organizeRow(data) {
  var newData = [];

  if (data.length === 0) {
    newData.push({
      id: "nothing",
      colum: [
        { label: "No Results", span: "" },
        { label: "", span: "" },
        { label: "", span: "" },
        { label: "", span: "" },
        { label: "", span: "" },
      ],
    });
    return newData;
  }

  data.forEach((elem) => {
    let text;
    let subTextStatus;
    let textBill;
    let subTextBill;
    let color;
    let transactionType;
    let newEntity;

    let customAvatarLetter = 'NA'; // Valor por defecto
    if (elem.transactionType === 'purchase') {
      customAvatarLetter = './css/svg.svg#check-round';
      color = "tdWithIcon td-green-icon";
      transactionType = 'Sale';
      newEntity = 'clientPurchase';
    } else if (elem.transactionType === 'sale') {
      customAvatarLetter = './css/svg.svg#check-round';
      color = "tdWithIcon td-red-icon";
      transactionType = 'Purchase';
      newEntity = 'clientSale';
    }

    switch (elem.payment_status) {
      case "paid":
        text = "Paid";
        subTextStatus = "";

        break;

      case "unpaid":
        if (elem.transactionType === 'purchase') {
          text = "Unpaid";
          subTextStatus = "Payment needed";

        } else if (elem.transactionType === 'sale') {
          text = "Unpaid";
          subTextStatus = "Payment needed";

        } else {
          text = "--";
          subTextStatus = "No Payment needed";

        }

        break;

      case "partially_paid":
        text = "Partially Paid";
        subTextStatus = "Payment needed";

        break;

      case "close":
        text = "Close";
        subTextStatus = "be closed";

        break;

      case "overdue":
        text = "overdue";
        subTextStatus = "Payment needed";

        break;

      case "credited":
        text = "Credited";
        subTextStatus = "Outstanding credit";

        break;

      case "":
        text = "";
        subTextStatus = "";

        break;

      default:
        break;
    }

    switch (elem.shipping_s) {
      case "ordered":
        textBill = "Ordered";
        subTextBill = "Orde placed";

        break;

      case "shipped":
        textBill = "Shipped";
        subTextBill = "Comming";

        break;

      case "delivered":
        textBill = "Delivered";
        subTextBill = "On Site";

        break;

      case "preparing":
        textBill = "Preparing";
        subTextBill = "Preparing Order";

        break;

      case "ready to pickup":
        textBill = "Ready to Pickup";
        subTextBill = "Ready for pickup";
        break;

      default:
        textBill = "-----";
        subTextBill = "-----";
        break;
    }

    newData.push({
      id: elem.id,
      tdDataDetail: getTdDataDetail(newEntity, elem.transactionType, elem.id),
      colum: [
        {
          label: transactionType,
          span: elem.purchaseCodeREF_td,
          style: {
            tdClass: color,
            svg: customAvatarLetter,
          },
        },

        { label: elem.general_total_price_dt, span: elem.total_expenses },

        {
          label: timeDate.friendlyDate(elem.dateDt),
          span: "",
        },

        {
          label: textBill,
          span: subTextBill,

        },

        {
          label: text,
          span: subTextStatus,

        },
      ],
    }); /*push*/
  }); /*forEach*/

  return newData;
}

export function organizeRowEntityChange(data) {
  let newData = "";
  let avatar = "";
  let changes_inputs;
  let changes_mt;

  data.forEach((elem) => {
    if (elem.avatar == "") {
      avatar = "css/img/pic/person.svg";
    } else {
      avatar = elem.avatar;
    }

    newData += `<cont> 
                        <user>
                            <photo class="photo" 
                            style="background-image: url('${avatar}')"></photo>
                            <title>${elem.user_name.trim()}</title>
                            <time>${timeDate.friendlyDate(elem.date_change) +
      " | " +
      timeDate.friendlyTime(
        elem.date_change.substring(10)
      )
      }</time>
                        </user>

                        <entry>
                            <div class="row">
                                <div class="c33">Data</div><!-- c16 -->
                                <div class="c33">From</div><!-- c16 -->
                                <div class="c33">To</div><!-- c16 -->
                            </div><!-- row --> 
        
                    `;

    changes_inputs = JSON.parse(elem.changes).input;

    changes_inputs.forEach((input) => {
      newData += `
                            <div class="row">
                                <div class="c33">${input.elemId}</div><!-- c16 -->
                                <div class="c33">${input.from}</div><!-- c16 -->
                                <div class="c33">${input.to}</div><!-- c16 -->
                            </div><!-- row --> 
            `;
    });

    changes_mt = JSON.parse(elem.changes).mt;
    if (changes_mt.length > 0) {
      newData += `     </entry>
                        <entry>
                            <div class="row mt-8">
                                <div class="c16">Status</div><!-- c16 -->
                                <div class="c16">Items</div><!-- c16 -->
                                <div class="c16">Units</div><!-- c16 -->
                                <div class="c16">Qty</div><!-- c16 -->
                                <div class="c16">Unit Price</div><!-- c16 -->
                                <div class="c16">Total</div><!-- c16 -->
                            </div><!-- row --> `;
    }

    changes_mt.forEach((mt) => {
      mt.from.forEach(function (mt_from, index) {
        newData += `
                    <div class="row">
                        <div class="c16">From</div><!-- c16 -->
                        <div class="c16">${mt_from.id}</div><!-- c16 -->
                        <div class="c16">${mt_from.selling_type
          }</div><!-- c16 -->
                        <div class="c16">${mt_from.qty}</div><!-- c16 -->
                        <div class="c16">${"$" + mt_from.price
          }</div><!-- c16 -->
                        <div class="c16">${"$" + mt_from.total
          }</div><!-- c16 -->
                    </div><!-- row -->`;

        // Verificar si hay datos en mt.to
        if (mt.to && mt.to[index]) {
          newData += `
                    <div class="row">
                        <div class="c16">To</div><!-- c16 -->
                        <div class="c16">${mt.to[index].id}</div><!-- c16 -->
                        <div class="c16">${mt.to[index].selling_type
            }</div><!-- c16 -->
                        <div class="c16">${mt.to[index].qty}</div><!-- c16 -->
                        <div class="c16">${"$" + mt.to[index].price
            }</div><!-- c16 -->
                        <div class="c16">${"$" + mt.to[index].total
            }</div><!-- c16 -->
                    </div><!-- row -->`;
        }
      });
    });

    newData += `     </entry>
                   <cont>`;
  }); /*forEach*/

  return newData;
} /*organizeRow*/